export enum ZIndex {
  MODAL = 1000,
  TROUSER_MODAL = 1001,
  TOP_NAV = 250,
  HEADER = 200,
  SIDE_NAV = 150,
  OVERLAY = 100,
  TH = 10,
}
